import React from "react";

const SectionImage = ({ webp, fallback, alt }) => (
  <picture>
    <source srcSet={webp} type="image/webp" />
    <img
      src={fallback}
      alt={alt}
      className="rounded-xl shadow-md w-full h-64 object-cover"
      loading="lazy"
    />
  </picture>
);

const About = () => {
  return (
    <section id="section2" className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">
          Acerca de Master Mop
        </h2>
        <div className="mx-auto mb-12 w-12 h-1 bg-orange-500 rounded"></div>

        <div className="flex flex-col md:flex-row items-center gap-10 mb-14">
          <div className="md:w-1/2">
            <SectionImage
              webp="/images/imagen1.webp"
              fallback="/images/imagen1.png"
              alt="Limpieza Profunda"
            />
          </div>
          <div className="md:w-1/2">
            <h3 className="text-orange-500 font-bold text-sm tracking-widest uppercase mb-2">
              Quiénes somos
            </h3>
            <h4 className="text-2xl font-bold text-gray-800 mb-3 border-l-4 border-orange-500 pl-3">
              Empresa 100% Mexicana
            </h4>
            <p className="text-gray-600 leading-relaxed">
              Somos una empresa dedicada a asegurar espacios limpios y proveer mantenimiento,
              ya sea para tu casa, oficina o negocio en Querétaro.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-10 mb-14">
          <div className="md:w-1/2 md:order-2">
            <SectionImage
              webp="/images/Imagen2.webp"
              fallback="/images/Imagen2.png"
              alt="Equipo de Limpieza"
            />
          </div>
          <div className="md:w-1/2 md:order-1">
            <h3 className="text-orange-500 font-bold text-sm tracking-widest uppercase mb-2">
              Qué ofrecemos
            </h3>
            <h4 className="text-2xl font-bold text-gray-800 mb-3 border-l-4 border-orange-500 pl-3">
              Calidad y Experiencia
            </h4>
            <p className="text-gray-600 leading-relaxed">
              Contamos con los mejores expertos en limpieza y mantenimiento. Nos
              aseguramos de ofrecer el más alto servicio de calidad utilizando los
              mejores recursos en el mercado.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-10">
          <div className="md:w-1/2">
            <SectionImage
              webp="/images/Imagen4.webp"
              fallback="/images/Imagen4.png"
              alt="Clientes Satisfechos"
            />
          </div>
          <div className="md:w-1/2">
            <h3 className="text-orange-500 font-bold text-sm tracking-widest uppercase mb-2">
              Nos distingue
            </h3>
            <h4 className="text-2xl font-bold text-gray-800 mb-3 border-l-4 border-orange-500 pl-3">
              Por qué elegirnos
            </h4>
            <ul className="space-y-2 text-gray-600">
              {[
                "Compromiso con la calidad",
                "Responsabilidad y profesionalismo",
                "Eficiencia",
                "Atención al cliente excepcional",
                "Precios competitivos",
                "Seguimiento",
              ].map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-orange-500 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
